export enum ContactDetailsActionsTypes {
  SET_CONTACT_DETAILS_MAP = 'contactDetails/SET_CONTACT_DETAILS_MAP',
}
